///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.rfq = abcsetup.rfq || {};
abcsetup.rfq.bid_requests = abcsetup.rfq.bid_requests || {};
abcsetup.rfq.bid_requests.approve = abcsetup.rfq.bid_requests.approve || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Variables
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.rfq.bid_requests.approve.items_table = null;
abcsetup.rfq.bid_requests.approve.non_items_table = null;
abcsetup.rfq.bid_requests.approve.no_response_table = null;


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.rfq.bid_requests.approve = {
    init() {
        abcsetup.setTitle('RFQ Bid Review');

        // Challenger bids
        abcsetup.rfq.bid_requests.approve.items_table = $('table#bid_review');

        // Init bid refused datatable
        if ($('#non-bid-table > table tbody tr').length > 0) {
            // Only initialize the DataTable if rows exist
            abcsetup.rfq.bid_requests.approve.non_items_table = abcsetup.datatables.client_side.init($('#non-bid-table > table'), {
                bInfo: true,
                "dom": 'lftipB',
                "responsive": true,
                "lengthMenu": [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, 'All']],
                "iDisplayLength": 10,
                "order": [[1, "asc"]],
                "searchable": true,
            });
        }

        // Init no-response datatable
        abcsetup.rfq.bid_requests.approve.no_response_table = abcsetup.datatables.client_side.init($('#no-response-table > table'), {
            bInfo: true,
            "dom": 'lftipB',
            "responsive": true,
            "lengthMenu": [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, 'All']],
            "iDisplayLength": 10,
            "order": [[0, "asc"]],
            "searchable": true,
        });

        // Attachments table
        abcsetup.datatables.client_side.init($('#supplier-attachments-table > table'), {
            bInfo: true,
            "responsive": true,
            "lengthMenu": [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, 'All']],
            "order": [[0, "asc"]],
            "columnDefs": [{
                "targets": 2,
                "orderable": false
            }],
        });

        /* LCU funcs only */
        if ($('#rfq_bid_type_id').length && $('#rfq_bid_type_id').val() == 30) {
            this._setupTablesToggle();

            $(document).on('change', '.form-check-input', function(e) {
                if ($(this).val() == 4) {
                    $(this).closest('tr').find('.acceptance-reason').attr('required', true);
                    $(this).closest('tr').find('.award-reason').attr('required', true);
                    return;
                }

                if ($(this).val() == 13) {
                    $(this).closest('tr').find('.acceptance-reason').attr('required', false);
                    $(this).closest('tr').find('.award-reason').attr('required', false);
                    return;
                }
            });
        }

        this._setupBidsAttachmentsToggle();
        // Not participating change.
        $('#no-response-table').hide();
        $(document).on('change', '[name=not_participating_toggle]', function () {
            $('#not-participating-toggle .btn').removeClass('active');

            if ($(this).val() === 'bid_refused') {
                $('#non-bid-table').show();
                $('#no-response-table').hide();
            } else {
                $('#non-bid-table').hide();
                $('#no-response-table').show();
            }
        });

        // Add tooltips to the response datatable controls
        $('td.dtr-control').attr('title', 'Click to expand/collapse supplier response');

        $('#save_bids_btn').on('click', () => {
            $('#bid_review_form [name=save_type]').val('save');
            this._on_submit({saveForLater: true});
        });
        $('#submit_bids_btn').on('click', () => {
            $('#bid_review_form [name=save_type]').val('submit');
            this._on_submit();
        });
        $('#close_event_btn').on('click', () => {
            $('#bid_review_form [name=save_type]').val('close');
            this._on_submit();
        });

        $(document).on('click', '[data-toggle=lightbox]', () => abcsetup.alerts.hide());

        this._bind_approve_reject_buttons();
        this._bind_incumbent_keeps_buttons();
        this._bind_no_incumbent_checkbox();

        // RFQ Event delete button clicked
        $(document).on('click', '.btn-reject', function () {
            var _this = $(this);

            abcsetup.alerts.prompt('Reject RFQ Bid', 'Please specify a reason to reject this bid back to the supplier:', function (resp) {
                if (resp[0] == true) {
                    abcsetup.rfq.bid_requests.approve.rejectBidBackToSupplier(_this.data('id'), _this.data('org_id'), resp[1]);
                }
            }, true);

            return false;
        });

        $(document).on('click', '.btn-copy-previous-row', function () {
            const black_list = ['rfq_bid_status_id'];
            const this_row = $(this).closest('tr');
            const previous_row = this_row.prev('tr');

            previous_row.find(':input[name^="bids["]:visible').each(function () {
                const field_name = $(this).attr('name').replace(/(^.*\[|]$)/g, '');
                if (black_list.includes(field_name)) {
                    return;
                }

                this_row.find(`[name^="bids["][name$="[${field_name}]"]`).val($(this).val()).trigger('change', {revalidate: true});
            });
        });

        $(document).on('click', '.btn-bid-details', function () {
            abcsetup.alerts.show($(this).data('alert_title'), $(this).parent().find('.bid-details').html());
        });

        $('input[name*="create_item_sap_num"]').on("change", function (event, {initialRun = false} = {}) {
            var parent_td = $(this).closest('td');
            var sap_field = $(parent_td).find('.challenger_sap_num');
            var pricing_team_review = $("#rfq_bid_requests_pricing_team_review").val();
            var rfq_bid_request_type = $("#rfq_bid_request_type").val();

            if (rfq_bid_request_type != 25) {
                if($(this).prop('checked')) {
                    sap_field.attr('required',false)
                    $(this).attr('required',true);
                } else {
                    sap_field.attr('required',true);
                    $(this).attr('required',false);
                }
            }
            else {
                if (pricing_team_review == 1) {
                    if($(this).prop('checked')) {
                        sap_field.attr('required',false)
                        $(this).attr('required',true);
                    } else {
                        sap_field.attr('required',true);
                        $(this).attr('required',false);
                    }
                } else {
                    sap_field.attr('required',false)
                    $(this).attr('required',false);
                }
            }
            sap_field.trigger('change');
        }).trigger('change', {initialRun : true});

        this._setup_conversion_elements();

        $("#incumbents_list tbody").find("tr").each(function(idx,row) {
            var convert_td = $(this).find('.convert');
            var abcid = convert_td.attr("data-abcid");
            var input_count = $('input[name*="converted_from_ids"][data-abcid="'+abcid+'"]').length;
            if (!input_count) {
                var input_field =
                '<div class="checkbox pt-1" style="width: 50px">'+
                    '<label>'+
                    '<input type="checkbox" name="converted_from_sap_num[]" value="'+abcid+'"'+
                        'class="convert-checkbox" data-abcid="{{ $RFQBid->sap_num }}"'+
                        'title="Convert the item to a solicited bid event">'+
                        '<span class="cr">'+
                            '<i class="cr-icon fa fa-check"></i>'+
                        '</span>'+
                        '</label>'+
                '</div>';
                $(convert_td[0]).append(input_field);
            }
        });

        // Init the RFQ comments lib confirmation lib.
        abcsetup.rfq.comments.init();
    },

    /**
     * Setup the bindings for "Incumbent Keeps" buttons.
     *
     * @private
     */
    _bind_incumbent_keeps_buttons() {
        const _this = this;

        $(document).on('click', '.incumbent-keeps-toggle > .btn', function (event) {
            event.preventDefault();
            const togglingOn = !$(this).hasClass('active');

            if (togglingOn) {
                $(this).addClass('active');
                $(this).next('input[name*=incumbent_keeps]').val(1).trigger('change');
                $('#incumbents_list th.incumbent-keeps-explanation,td.incumbent-keeps-explanation').show();

                $('#bid_review tr.abcid-' + $(this).data('abcid')).each(function () {
                    _this._reject_bid(this);
                });
            } else {
                $(this).removeClass('active');
                $(this).next('input[name*=incumbent_keeps]').val(0).trigger('change');

                if ($('#incumbents_list td.incumbent-keeps-explanation textarea:visible').length === 0) {
                    $('#incumbents_list th.incumbent-keeps-explanation,td.incumbent-keeps-explanation').hide();
                }

                $('#bid_review tr.abcid-' + $(this).data('abcid')).each(function () {
                    _this._reset_bid_status(this);
                });
            }
        });

        if ($('.incumbent-keeps-toggle > .btn.active').length === 0) {
            $('#incumbents_list th.incumbent-keeps-explanation,td.incumbent-keeps-explanation').hide();
        } else {
            $('.incumbent-keeps-toggle > .btn:not(.active)').closest('tr').find('td.incumbent-keeps-explanation textarea').hide();

            // Auto reject challenger bids with saved incumbent keeps
            $('.incumbent-keeps-toggle > .btn.active').each(function() {
                $('#bid_review tr.abcid-' + $(this).data('abcid')).each(function () {
                    _this._reject_bid(this);
                });
            });
        }
    },

    /**
     * Setup the bindings for approving and rejecting individual bids.
     *
     * @private
     */
    _bind_approve_reject_buttons() {
        const _this = this;
        const bid_radio_selector = '[name^="bids["][name$="[rfq_bid_status_id]"]';

        $(document).on('click', `label:has(${bid_radio_selector})`, function (event) {
            event.preventDefault();
            const was_already_checked = $(this).find('input').prop('checked');

            if (was_already_checked) { // Unchecking a checked checkbox. Work is already done for this action.
                _this._reset_bid_status($(this).closest('tr'));
                return;
            }

            if ($(this).hasClass('btn-outline-success')) {
                _this._approve_bid($(this).closest('tr'));

                const bid_row = $(this).closest('tr');

                // Mark the same item for other suppliers as rejected.
                $('tr.abcid-' + bid_row.data('abcid')).not(bid_row).each(function () {
                    if ($(this).find(`${bid_radio_selector}:checked`).length === 0) {
                        $(this).find(`.btn-outline-danger`).trigger('click');
                    }
                });
            } else if ($(this).hasClass('btn-outline-danger')) {
                _this._reject_bid($(this).closest('tr'));
            } else if ($(this).hasClass('btn-outline-warning')) {
                _this._reject_bid_to_vendor($(this).closest('tr'));
            }
        });

        // Initialize rows.
        $('.bid-status-toggle').each(function () {
            const ActiveButton = $(this).find('.active');
            const Row = $(this).closest('tr');

            if (ActiveButton.hasClass('btn-outline-success')) {
                return _this._approve_bid(Row);
            } else if (ActiveButton.hasClass('btn-outline-danger')) {
                return _this._reject_bid(Row, true);
            } else if (ActiveButton.hasClass('btn-outline-warning')) {
                return _this._reject_bid_to_vendor(Row, true);
            }

            _this._reset_bid_status(Row);
        });
    },

    /**
     * Reset the given row's approval status.
     *
     * @param row
     * @private
     */
    _reset_bid_status(row) {
        const BidStatusToggle = $(row).find('.bid-status-toggle');

        BidStatusToggle.find('label').removeClass('active');
        BidStatusToggle.find('input').prop('checked', false).trigger('change', {revalidate: true});

        $(row).removeClass('approve done reject')
            .find('.hidden-for-reject').removeClass('hidden-for-reject').parents('.cell-container').children().show();
        $(row).find('.hidden-for-reject-to-vendor').removeClass('hidden-for-reject-to-vendor').parents('.cell-container').children().show();
        $(row).find('.hidden-for-reject-to-vendor-grx').removeClass('hidden-for-reject-to-vendor-grx').parents('.cell-container').children().show();
        $(row).find('[name*=rejection_comments]').parents('.cell-container').children().hide();
        $(row).find('[name*=swiss_reject_comments]').parents('.cell-container').children().hide();
        $(row).find('[name*=grx_vendor_reject_reason]').parents('.cell-container').children().hide();
    },

    /**
     * Approve the bid in the given row.
     *
     * @param row
     * @private
     */
     _reject_bid_to_vendor(row, initialRun = false) {
        const RejectToVendorButton = $(row).find('.bid-status-toggle .btn-outline-warning');
        const Row = $(row);

        this._reset_bid_status(row);

        RejectToVendorButton.addClass('active');
        RejectToVendorButton.find('input').prop('checked', true).trigger('change', {revalidate: true});

        Row.removeClass('approve').addClass('done reject')
            .find(':input:visible:not([name*=rfq_bid_status_id],[name*=swiss_reject_comments]),.select2-hidden-accessible').parents('.cell-container').children().addClass('hidden-for-reject-to-vendor').hide()

        Row.removeClass('approve').addClass('done reject')
            .find(':input:visible:not([name*=rfq_bid_status_id],[name*=grx_vendor_reject_reason]),.select2-hidden-accessible').parents('.cell-container').children().addClass('hidden-for-reject-to-vendor-grx').hide()

        if (abcsetup.userRole && abcsetup.userRole.class=='grx_cm'){
            Row.find('[name*=grx_vendor_reject_reason]').parents('.cell-container').children().each(function(){
                $(this).show();
                var dom_id = $(this).attr('id');
                //abcsetup.scrollIntoView($(this).closest('td')[0], $('#bid_review').closest('.syncscroll')[0]);
            });
        } else {
            Row.find('[name*=swiss_reject_comments]').parents('.cell-container').children().each(function(){
                $(this).show();
                var dom_id = $(this).attr('id');
                //abcsetup.scrollIntoView($(this).closest('td')[0], $('#bid_review').closest('.syncscroll')[0]);
            });
        }

        if (initialRun && Row.find('.select2:not(.select2-hidden-accessible)')) {
            // The select component hasn't initialized yet. Since they don't have an event for that, we're watching for when it does.
            Row.find('.select2:not(.select2-hidden-accessible').each(function () {
                const maxWait = 1000;
                let currentWait = 0;
                let interval = 300;
                const intervalID = window.setInterval(() => {
                    currentWait += interval;
                    if ($(this).hasClass('select2-hidden-accessible')) {
                        $(this).parents('.cell-container').children().addClass('hidden-for-reject-to-vendor').hide();
                        $(this).parents('.cell-container').children().addClass('hidden-for-reject-to-vendor-grx').hide();
                        window.clearInterval(intervalID);
                    } else if (currentWait >= maxWait) {
                        window.clearInterval(intervalID);
                    }
                }, interval);
            });
        }
    },

    /**
     * Approve the bid in the given row.
     *
     * @param row
     * @private
     */
    _approve_bid(row) {
        const ApproveButton = $(row).find('.bid-status-toggle .btn-outline-success');

        this._reset_bid_status(row);

        ApproveButton.addClass('active');
        ApproveButton.find('input').prop('checked', true).trigger('change', {revalidate: true});

        $(row).removeClass('reject').addClass('done approve');
    },

    /**
     * Reject the bid in the given row.
     *
     * @param row
     * @param {boolean} initialRun
     * @private
     */
    _reject_bid(row, initialRun = false) {
        const Row = $(row);
        const RejectButton = Row.find('.bid-status-toggle .btn-outline-danger');

        this._reset_bid_status(row);

        RejectButton.addClass('active');
        RejectButton.find('input').prop('checked', true).trigger('change', {revalidate: true});

        Row.removeClass('approve')
            .addClass('done reject').find(':input:visible:not([name*=rfq_bid_status_id],[name*=rejection_comments]),.select2-hidden-accessible').parents('.cell-container').children().addClass('hidden-for-reject').hide();

        /** We need to uncheck the create_item_sap_num checkbox if the bid was rejected */
        Row.find('[name*=create_item_sap_num]').prop('checked', false);

        Row.find('.reject_reason').parents('.cell-container').children().each(function(){
            $(this).show();
            var dom_id = $(this).attr('id');
            if (abcsetup.userRole && abcsetup.userRole.class=='abc_swiss'){
                $('.reject-to-vendor-comments textarea.reject_reason').hide();
            }
            //abcsetup.scrollIntoView($(this).closest('td')[0], $('#bid_review').closest('.syncscroll')[0]);
        });

        if (initialRun && Row.find('.select2:not(.select2-hidden-accessible)')) {
            // The select component hasn't initialized yet. Since they don't have an event for that, we're watching for when it does.
            Row.find('.select2:not(.select2-hidden-accessible').each(function () {
                const maxWait = 1000;
                let currentWait = 0;
                let interval = 300;
                const intervalID = window.setInterval(() => {
                    currentWait += interval;
                    if ($(this).hasClass('select2-hidden-accessible')) {
                        $(this).parents('.cell-container').children().addClass('hidden-for-reject').hide();
                        window.clearInterval(intervalID);
                    } else if (currentWait >= maxWait) {
                        window.clearInterval(intervalID);
                    }
                }, interval);
            });
        }
    },

    /**
     * Submit the bid review form.
     *
     * @private
     */
    _on_submit({saveForLater = false, convertBid = false} = {}) {
        const showBidsTable = () => $('#bids-toggle :radio[value=bids]').parents('.btn').trigger('click');
        const showSupplierAttachmentsTable = () => $('#bids-toggle :radio[value=supplier_attachments]').parents('.btn').trigger('click');

        // Verify that all offer letters for suppliers that have approved bids have been replaced by offer letters uploaded by a GRx CM.
        const checkOfferLetterValidity = () => {
            showSupplierAttachmentsTable();
            $(`#supplier-attachments-table .offer-letter button[data-replace_route]`).each(function () {
                fieldValidate.resetValidation(this);
            });

            const org_ids_with_approved_bid = _.uniq($('#bid_review .bid-status-toggle .btn-outline-success.active').parents('tr').map(function () {
                return $(this).data('org_id');
            }));

            var WagsItem = true;
            org_ids_with_approved_bid.forEach(org_id => {
                var Wags = $(`#bid_review tr[data-org_id=${org_id}] .wags`);
                Wags.each( function( index, element ) {
                    if ($(this).val() == 0 && $(this).val() != '') {
                        WagsItem = false;
                        return;
                    }
                });
            });

            org_ids_with_approved_bid.forEach(org_id => {
                const OfferLetter = $(`#supplier-attachments-table tr[data-org_id=${org_id}] .offer-letter`);
                const OfferLetterButton = OfferLetter.find('button[data-replace_route]')[0];
                const uploader_role_class = OfferLetter.data('uploader_role_class');
                var rfq_bid_requests_pricing_team_review = $('#rfq_bid_requests_pricing_team_review').val();
                var Wags = $(`#bid_review tr[data-org_id=${org_id}] .wags`);

                if (abcsetup.userRole && abcsetup.userRole.class!=='abc_swiss') {
                    // The Swiss Team can optionally replace the Offer Letter
                    // -> If they do: The CM does not need to replace the Offer Letter
                    // -> If they DONT: The CM NEEDS to replace the Offer Letter
                    if ((uploader_role_class !== 'grx_cm' && uploader_role_class !== 'grx_src_manager' && uploader_role_class !== 'abc_swiss') && OfferLetterButton) {
                        if (Wags) {
                            if (WagsItem || rfq_bid_requests_pricing_team_review == 1) {
                                OfferLetterButton.setCustomValidity('\nThe supplier\'s offer letter must be replaced.');
                            }
                        }
                        else {
                            OfferLetterButton.setCustomValidity('\nThe supplier\'s offer letter must be replaced.');
                        }
                    }
                }
            });
            console.log('supplier-attachments-table');
            return fieldValidate.checkValidity($('#supplier-attachments-table'));
        };

        const checkBidsValidity = () => {
            showBidsTable();
            const select2s_are_valid = $('.select2-hidden-accessible').toArray().map(select2 => {
                // requiredIf doesn't seem to support radio inputs yet.
                return $(select2).data('select2').$container.is(':visible') ? fieldValidate.checkValidity(select2) : true;
            }).every(Boolean);

            console.log('bid_review_form');
            return fieldValidate.checkValidity('#bid_review_form') && select2s_are_valid;
        };

        let isValid = false;

        if ($('#rfq_bid_type_id').length && $('#rfq_bid_type_id').val() != 30) {
            if (saveForLater) {
                isValid = true;
            } else if (convertBid) {
                fieldValidate.resetValidation($('#bid_review_form'));
                // PharmaGen Formulary Synergy does not have a select.incumbent-sap-num field which is why
                // we have the below logic
                if ($('#convert-btn').attr('data-unsolicited') == 'false') {
                    isValid = true;
                } else {
                    isValid = fieldValidate.checkValidity($('tr:has(.convert-checkbox:checked) select.incumbent-sap-num'));
                }

            } else {
                isValid = checkBidsValidity() && checkOfferLetterValidity();
            }
        } else {
            isValid = checkBidsValidity();
        }

        if (isValid) {
            showBidsTable();
            abcsetup.blockUI(true);
            $('#bid_review_form').trigger('submit');
        } else {
            // The sticky header on the challenger bids table can cover the field that's in error. Scrolling up a bit to prevent this.
            window.scrollBy(0, -100);
        }
    },

    _setupBidsAttachmentsToggle() {
        $('#supplier-attachments-table').hide();
        $(document).on('change', '[name=bids_toggle]', function () {
            $('#bids-toggle .btn').removeClass('active');

            if ($(this).val() === 'supplier_attachments') {
                $('#bid-review-table-container').hide();
                $('#supplier-attachments-table').show();
            } else {
                $('#bid-review-table-container').show();
                $('#supplier-attachments-table').hide();
            }
        });
    },

    /**
     * Reject a bid back to the supplier.
     *
     * @param id
     * @param org_id
     * @param message
     */
    rejectBidBackToSupplier: function (id, org_id, message = null) {
        abcsetup.blockUI(true);

        axios.post('/api/rfq/bid_requests/reject', {id: id, org_id: org_id, message: message}).then(response => {
            // Remove the org related rows from the datatables
            // abcsetup.rfq.bid_requests.approve.items_table.rows('tr[data-org_id="' + org_id + '"]').remove();
            abcsetup.rfq.bid_requests.approve.items_table.find('tr[data-org_id="' + org_id + '"]').remove();
            abcsetup.rfq.bid_requests.approve.non_items_table.rows('tr[data-org_id="' + org_id + '"]').remove().draw();
            abcsetup.unblockUI();
        });
    },

    uploadDoneBeforeAutoAppend() {
        $(abcsetup.uploader.button).parents('.offer-letter')
            .data('uploader_role_class', abcsetup.userRole ? abcsetup.userRole.class : 'grx_cm') // We'll assume it's a grx_cm since we're on the approval page. I'm guessing this else branch shouldn't ever be hit though.
    },

    uploadDone() {
        window.location.reload();
    },

    _bind_no_incumbent_checkbox() {
        $(document).on('change', ':checkbox[name*=no_incumbent]', function () {
            if ($(this).prop('checked')) {
                // Clear selected incumbent, if any.
                $(this).parents('td').find('.select2-hidden-accessible').val(null).trigger('change');
            }
        });
    },

    _setup_conversion_elements() {
        const _this = this;
        const updateUIBasedOnConvertCheckboxes = () => {
            $('#convert-btn').attr('disabled', $('.convert-checkbox:checked').length === 0);

            $('.convert-checkbox').each(function () {
                const noIncumbentCheckbox = $(this).parents('tr').find('.no-incumbent-checkbox');
                if (!noIncumbentCheckbox) {
                    return;
                }

                noIncumbentCheckbox.attr('disabled', $(this).is(':checked'));
                if ($(this).is(':checked')) {
                    noIncumbentCheckbox.prop('checked', false).trigger('change', {revalidate: true});
                }
            });
        };

        // The convert item checkbox was clicked
        $(document).on('click', '.convert-checkbox', updateUIBasedOnConvertCheckboxes);

        // The convert item button was clicked
        $(document).on('click', '#convert-btn', function () {
            $('#bid_review_form [name=save_type]').val('convert');
            _this._on_submit({convertBid: true});
        });

        updateUIBasedOnConvertCheckboxes();
    },

    _setupTablesToggle() {
        // Hide all tables except the default one
        $('.table-section').not('#bid-review-table-container').hide();
        
        // Handle table toggle changes
        $(document).on('change', '[name=tables_toggle]', function () {
            $('#all-tables-toggle .btn').removeClass('active');
            $(this).parent().addClass('active');
            
            // Hide all tables
            $('.table-section').hide();
            
            // Show the selected table
            const selectedValue = $(this).val();
            if (selectedValue === 'bids') {
                $('#bid-review-table-container').show();
            } else if (selectedValue === 'all_products') {
                $('#all-products-table').show();
            } else if (selectedValue === 'supplier_attachments') {
                $('#supplier-attachments-table').show();
            } else if (selectedValue === 'bid_refused') {
                $('#non-bid-table').show();
            } else if (selectedValue === 'no_response') {
                $('#no-response-table').show();
            }
        });
    }
}
